
import { Create, regex, required, SimpleForm, TextInput } from "react-admin";
import { AddressInputs } from "../../components/address-inputs.component";
import { Col, Row } from "../../components/grid.component";
import { formatCNPJ, normalizeDocumentForApi } from "../../utils/mask.util";
import { regexs } from "../../utils/regexs.util";

export const CompanyCreate = (props: any) => {
  return (
    <Create
      transform={(data: any) => ({
        ...data,
        cnpj: normalizeDocumentForApi(data.cnpj),
      })}
      {...props}
    >
      <SimpleForm>
        <Row spacing={2}>
          <Col sm={6}>
            <TextInput fullWidth source="name" label="Nome" validate={required()} />
          </Col>
          <Col sm={6}>
            <TextInput
              fullWidth
              source="cnpj"
              defaultValue=""
              parse={(value: string) => value?.toUpperCase()}
              format={(value: string) => formatCNPJ(value)}
              validate={[required(), regex(regexs.CNPJ_REGEX, "CNPJ Inválido")]}
              label="CNPJ"
            />
          </Col>
        </Row>
        <AddressInputs />
      </SimpleForm>
    </Create>
  );
};
